import { render } from "./SuperAdmin.vue?vue&type=template&id=da6b36fe&scoped=true&ts=true"
import script from "./SuperAdmin.vue?vue&type=script&lang=ts"
export * from "./SuperAdmin.vue?vue&type=script&lang=ts"

import "./SuperAdmin.vue?vue&type=style&index=0&id=da6b36fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da6b36fe"]])

export default __exports__